import { useState } from 'react';
import themeGet from '@styled-system/theme-get';
import { Alert, Button, Form, Input } from 'antd';
import styled from 'styled-components';
import Section from '../../components/Section';
import Card from '../../components/UI/Card';
import Layout from '../../components/UI/Layout';
import { useAuth } from '../../context/Auth';
import { ReactComponent as Logo } from './../../assets/img/PXUSLogo.svg';
import loginPageImage from './../../assets/img/loginPageImage.png';

const StyledSection = styled(Section)`
    max-width: 500px;
    margin: auto;
    text-align: center;
`;

const StyledForm = styled(Form)`
    margin-top: ${themeGet('margin.top')};
    max-width: 345px;
    margin: 0 auto;
    .ant-form-item-label {
        padding: 0px;
        height: 27px;
    }
`;
const StyledAlert = styled(Alert)`
    margin-bottom: ${themeGet('margin.top')};
`;

const StyledLogo = styled(Logo)`
    margin: 48px 0px;
    transform: scale(1.7);
`;

const StyledDiv = styled('div')`
    .ant-card {
        background-color: #ffffff;
        min-height: 630px;
        background-position: center bottom -56px;
        background-size: 130%;
        background-image: url(${loginPageImage});
        background-repeat: no-repeat;
        border: #ffffff solid 6px;
        box-shadow: 3px 3px 6px 0px #888888ad;
        background-color: ${themeGet('color.background')};
    }
`;

const LoginPage = () => {
    const auth = useAuth();
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const onFinish = ({ username, password }) => {
        setIsLoading(true);
        auth.login(username, password)
            .then(() => {
                setError(null);
                setIsLoading(false);
            })
            .catch((err) => {
                setError(err);
                setIsLoading(false);
            });
    };

    return (
        <Layout>
            <StyledSection>
                <StyledDiv>
                    <Card bordered={true} showShadow={false}>
                        <StyledForm
                            name="basic"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 12 }}
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <StyledLogo>
                                <Logo alt="PLXUS" />
                            </StyledLogo>

                            {error && (
                                <StyledAlert
                                    message={error.message}
                                    type="error"
                                />
                            )}
                            <Form.Item
                                label={
                                    <span
                                        style={{
                                            fontSize: '12px',
                                            fontWeight: 700,
                                        }}
                                    >
                                        Username
                                    </span>
                                }
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your username!',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={
                                    <span
                                        style={{
                                            fontSize: '12px',
                                            fontWeight: 700,
                                        }}
                                    >
                                        Password
                                    </span>
                                }
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password!',
                                    },
                                ]}
                                style={{ marginBottom: 0 }}
                            >
                                <Input.Password />
                            </Form.Item>
                            <Form.Item wrapperCol={{ span: 24 }}>
                                <Button
                                    type="link"
                                    onClick={auth.forgotPassword}
                                >
                                    Forgot Password
                                </Button>
                            </Form.Item>
                            <Form.Item wrapperCol={{ span: 24 }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={isLoading}
                                    style={{ width: '100%' }}
                                >
                                    Log In
                                </Button>
                            </Form.Item>
                        </StyledForm>
                    </Card>
                </StyledDiv>
            </StyledSection>
        </Layout>
    );
};

export default LoginPage;
